/**
 * Storefront paths that already belong to the application. Keep this list in
 * sync with apps/api/app/Domain/SiteConfig/Support/ReservedPageSlugs.php.
 * `home` is special: it is the builder home page, not a new page slug.
 */
export const RESERVED_PAGE_SLUGS = new Set([
  'home',
  'admin',
  'login',
  'sign',
  'account',
  'vehicles',
  'about',
  'contact',
  'faq',
  'locations',
  'deals',
  'services',
  'legal',
  'super-admin',
  'api',
  'storage',
  'site-config',
  'site-pages',
  'site-images',
  'assets',
  'static',
  'health',
  'platform',
  'sitemap',
  'robots',
  'manifest',
  'sw',
  'favicon',
]);

export function pageSlugError(slug: string): string | null {
  const value = slug.trim();
  if (!value) return 'Enter a URL slug.';
  if (value.length > 60) return 'Use 60 characters or fewer.';
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)) {
    return 'Use lowercase letters, numbers and hyphens only.';
  }
  if (RESERVED_PAGE_SLUGS.has(value)) {
    return 'This URL is reserved by the storefront. Choose another one.';
  }
  return null;
}

export function slugifyPageName(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}

export function pageNameFromSlug(slug: string): string {
  if (slug === 'home') return 'Home';
  return slug
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
